import Vue from 'vue'
import router from '@/router'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ ease: 'ease', speed: 500 });

const auths = [];
// router pageName
const whiteList = ['Login','Error401'];
class permission {
    // key:  ['aaas','bbb','cc'] || 'aaa'
    Check(key) {
        if(!key) return true;
        var checkauth = (authCode)=> {  
            if (authCode) {
                for (let i in this.auths) {
                    if (this.auths[i] === authCode)
                        return true
                }
                return false
            }
            return true
        };
        //判断多个权限
        if(typeof(key)=='string'){
            return checkauth(key)
        }else if(typeof(key)=='object'){
            for (let index = 0; index < key.length; index++) {
                if(checkauth(key[index])){
                    return true
                }
            }
            return false
        }
        
    }
    setAuths(list) {
        if (list && list.length) {
            this.auths = list
            sessionStorage.setItem('srm_auths', JSON.stringify(this.auths || []))
        } else {
            this.auths = JSON.parse(sessionStorage.getItem('srm_auths')) || []
        }
    }
    removeAuths() {
        this.auths = []
        sessionStorage.removeItem('auths')
    }
}

const Permission = new permission()

Permission.setAuths()

Vue.directive("authority", {
    inserted(el, binding) {
        if (!Permission.Check(binding.value))
            el.parentNode && el.parentNode.removeChild(el);
    },
});
//路由守卫
router.beforeEach((to, from, next) => {
    NProgress.start()
    // 白名单
    if (whiteList.find(i=>i==to.name)) {
        next();
    } else {
        //写一些判断拉
        // next({ path: '/login' });
    }
    ///先让它过==
    next();
    //==========
    NProgress.done()
})

// 全局后置钩子
router.afterEach(transition => {
    NProgress.done()
})

export default Permission